import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Floor, FloorItem } from 'src/app/features/reservations/models/Reservation';
import { Lookup } from 'src/app/models/Lookup';
import { TakeawayOrderService } from '../../../services/TakeawayOrder.service';
import { TakeawayTableProblemComponent } from './takeaway-table-problem/takeaway-table-problem.component';
import { TranslateService } from '@ngx-translate/core';

export interface DialogData {
  restaurantId: number,
  floorId: number,
  tablesToSelect: []
}
@Component({
  selector: 'app-choose-table',
  templateUrl: './choose-table.component.html'
})
export class ChooseTableComponent implements OnInit {
  loading = false;
  isSubmitted = false;

  floorsLoading = true;
  floorLoading = true;
  floorsList: Lookup[] = [];
  floorId!: number;
  floor!: Floor;

  tablesToSelect = this.data.tablesToSelect || [];
  selectedTables: FloorItem[] = [];
  reservationResponse!: any;

  constructor(
    private service: TakeawayOrderService,
    private dialogRef: MatDialogRef<ChooseTableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.floorId = this.data.floorId;
    this.ResFloorsList();
  }

  ResFloorsList() {
    this.floorsList = [];
    this.floorsLoading = true;
    this.service.ResFloorsList(this.data.restaurantId).subscribe(
      (data: any) => {
        if (data) {
          this.floorsLoading = false;
          this.floorsList = data;
          if (!this.floorId) { this.floorId = data[0].id; }
          if (this.floorId) {
            this.ResFloorsChangeTable();
          }
        }
      }, err => {
        console.error(err);
      });
  }
  ResFloorsChangeTable(floorId: number = this.floorId) {
    this.floorLoading = true;
    this.floorId = floorId;
    this.service.ResFloorsChangeTakeAwayTable(this.data.restaurantId, this.floorId).subscribe(
      (data: any) => {
        this.floorLoading = false;
        this.floor = data.floors[0];
      }, err => {
        console.error(err);
      });
  }
  CheckReservation() {
    const slectedTablesId = this.selectedTables.map((x: any) => x.id);
    this.reservationResponse = null;
    if (
      this.floor?.id &&
      this.selectedTables?.length
    ) {
      this.loading = true;
      let data = {
        restaurantsId: this.data.restaurantId,
        tabels: slectedTablesId
      }
      this.service.ResCheckTakeAwayChangeTable(data).subscribe(response => {
        this.loading = false;
        this.reservationResponse = response;
      }, error => {
        this.loading = false;
      });
    }
  }

  chooseTable() {
    if (this.reservationResponse.result?.success) {
      this.dialogRef.close({
        tables: this.selectedTables,
        floorId: this.floorId
      });
    } else {
      this.openProblemsDialog(1);
    }
  }

  openProblemsDialog(errorType: number) {
    const dialogRef = this.dialog.open(TakeawayTableProblemComponent, {
      width: '50rem',
      data: {
        reservationResponse: this.reservationResponse,
        errorType
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.dialogRef.close(true);
        // this.service.refreshList.next(true);
      }
    });
  }
}
